import { API_URL } from "./config.js";
import { getToken, getUsername, requireAdmin } from "./auth.js";

document.addEventListener("DOMContentLoaded", () => {
  if (!requireAdmin()) return;

  const form = document.getElementById("create-user-form");
  const usersList = document.getElementById("users-list");
  const token = getToken();
  const currentUser = getUsername();

  async function fetchUsers() {
    if (!token) return;
    const res = await fetch(`${API_URL}/admin/users`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const data = await res.json();
    usersList.innerHTML = "";
    if (data.users && data.users.length) {
      data.users.forEach((user) => {
        const isCurrent = user.username === currentUser;
        const div = document.createElement("div");
        div.className =
          "p-3 bg-gray-50 rounded shadow flex justify-between items-center";
        div.innerHTML = `<span><b>${user.username}</b> - <span class='text-gray-700'>${user.role}</span></span>`;
        if (!isCurrent) {
          const delBtn = document.createElement("button");
          delBtn.textContent = "Eliminar";
          delBtn.className =
            "ml-4 px-3 py-1 bg-red-600 text-white rounded hover:bg-red-800 transition";
          delBtn.onclick = () => {
            window.showConfirmDialog({
              message: `¿Eliminar usuario ${user.username}?`,
              onConfirm: async () => {
                const res = await fetch(
                  `${API_URL}/admin/delete-user/${user.username}`,
                  {
                    method: "DELETE",
                    headers: { Authorization: `Bearer ${token}` },
                  },
                );
                const result = await res.json();
                if (res.ok) {
                  fetchUsers();
                  window.showSnackbar("Usuario eliminado", "success");
                } else {
                  window.showSnackbar(
                    result.error || "Error al eliminar usuario",
                    "error",
                  );
                }
              },
              onCancel: () => {},
            });
          };
          div.appendChild(delBtn);
        } else {
          const you = document.createElement("span");
          you.textContent = " (tú)";
          you.className = "ml-2 text-xs text-gray-500";
          div.appendChild(you);
        }
        usersList.appendChild(div);
      });
    } else {
      usersList.innerHTML =
        '<span class="text-gray-500">No hay usuarios registrados.</span>';
    }
  }

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    if (!token) return;
    const formData = new FormData(form);
    const data = Object.fromEntries(formData.entries());
    const res = await fetch(`${API_URL}/admin/create-user`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });
    const result = await res.json();
    if (res.ok) {
      form.reset();
      fetchUsers();
      window.showSnackbar("Usuario creado", "success");
    } else {
      window.showSnackbar(result.error || "Error al crear usuario", "error");
    }
  });

  fetchUsers();
});
